import { FC, useCallback } from 'react';
import cn from 'classnames';

import './Table.scss';

type TableColumn = {
    key: string;
    label: string;
};

type TableRow = {
    [key: string]: any;
};

type TableProps = {
    id?: string;
    columns: TableColumn[];
    data: TableRow[];
    inverted?: boolean;
    clickable?: boolean;
    selected?: number | string | null;
    onRowClick?: any;
    noHeader?: boolean;
};

const Table: FC<TableProps> = ({
    id,
    columns,
    data,
    inverted,
    clickable,
    selected,
    noHeader,
    onRowClick,
}) => {
    const handleRowClick = useCallback(
        e => {
            const { index } = e.currentTarget.dataset;
            const rowData = data[index];
            onRowClick && onRowClick(rowData);
        },
        [data, onRowClick],
    );

    if (columns.length === 0) return null;

    return (
        data.length ? <table
            {...(id ? { id: id } : {})}
            className={cn('table', {
                table_inverted: inverted,
                table_clickable: clickable,
            })}
            cellPadding={0}
            cellSpacing={0}
        >
            {!noHeader && (
                <thead>
                    <tr>
                        {columns.map((e, index) => (
                            <th key={e.key}>{e.label}</th>
                        ))}
                    </tr>
                </thead>
            )}
            <tbody>
                {data.map((item, rowIndex) => (
                    <tr
                        className={cn({
                            table__row_selected: selected === rowIndex,
                        })}
                        key={rowIndex}
                        data-index={rowIndex}
                        onClick={handleRowClick}
                    >
                        {columns.map(({ key }, cellIndex) => {
                            const value = typeof item[key] === 'number' ? item[key].toLocaleString() : item[key]
                            return <td key={cellIndex}>{item[key] ? value : ""}</td>
                        })}
                    </tr>))
                }
            </tbody>
        </table> : <div className="text-center">no data available</div>
    );
};

export default Table;
